import { render, staticRenderFns } from "./tour_info.vue?vue&type=template&id=3681768f&scoped=true&lang=pug"
import script from "./tour_info.vue?vue&type=script&lang=js"
export * from "./tour_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3681768f",
  null
  
)

export default component.exports